import { jsxs as b, Fragment as q, jsx as s } from "react/jsx-runtime";
import { forwardRef as x, useState as I } from "react";
import { FormControl as S } from "../FormControl/FormControl.mjs";
import { InputBase as y } from "../Input/InputBase.mjs";
import { combineClasses as v } from "../../../utils/combineClasses.mjs";
import "react-nanny";
import { PasswordRequirements as O } from "./PasswordRequirements.mjs";
import { PasswordToggleButton as T } from "./PasswordToggleButton.mjs";
import { PasswordInputStatus as j } from "./PasswordInputStatus.mjs";
const k = x((m, l) => {
  const {
    name: t,
    className: d,
    controlStyleProps: p,
    controlClassName: c,
    "data-testid": r,
    error: u,
    passwordRequirements: e,
    hideOptionalLabel: f = !1,
    id: a = t,
    isDisabled: i,
    isReadOnly: n,
    isRequired: w,
    label: h,
    variant: P,
    ...g
  } = m, [o, C] = I(!1), N = () => C(!o), R = v("password-input", d);
  return /* @__PURE__ */ b(q, { children: [
    /* @__PURE__ */ s(
      S,
      {
        name: t,
        hideOptionalLabel: f,
        id: a,
        error: u,
        label: h,
        isDisabled: i,
        isReadOnly: n,
        isRequired: w,
        formHelperText: e && e.length > 0 && /* @__PURE__ */ s(O, { id: a, requirements: e }),
        "data-testid": r && `${r}-control`,
        className: c,
        ...p,
        children: /* @__PURE__ */ s(
          y,
          {
            ref: l,
            name: t,
            className: R,
            "data-testid": r,
            type: o ? "text" : "password",
            inputRightElementOverride: /* @__PURE__ */ s(
              T,
              {
                onClick: N,
                isDisabled: i,
                isPasswordShown: o
              }
            ),
            variant: n ? "filled" : P,
            ...g
          }
        )
      }
    ),
    e && e.length > 0 && /* @__PURE__ */ s(j, { requirements: e })
  ] });
});
k.displayName = "PasswordInput";
export {
  k as PasswordInput
};
